/**
 * BookingWaitlistService — Phase 7b
 *
 * Waitlist entries for resources that are currently unavailable. Join the
 * waitlist with <code>join</code>; when an offer arrives (status moves to
 * "Offered"), the user has the configured claim window to call <code>claim</code>.
 *
 * Route: api/booking-waitlist
 */
import { BaseService } from '../base';
export class BookingWaitlistService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? BookingWaitlistService.DEFAULT_SERVICE_PATH,
            basePath: BookingWaitlistService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    async listByResource(resourceId) {
        const response = await this.listByResourceRaw(resourceId);
        return response.data ?? [];
    }
    listByResourceRaw(resourceId) {
        return this.http.get(this.buildUrl(`by-resource/${resourceId}`));
    }
    async join(entry) {
        const response = await this.joinRaw(entry);
        return response.data ?? null;
    }
    joinRaw(entry) {
        return this.http.post(this.buildUrl(), entry);
    }
    /**
     * Claim an offered slot. Returns the resulting status ("Claimed" on success,
     * "Expired" if the claim window has passed).
     */
    async claim(waitlistId) {
        const response = await this.claimRaw(waitlistId);
        return response.data ?? null;
    }
    claimRaw(waitlistId) {
        return this.http.put(this.buildUrl(`${waitlistId}/claim`), {});
    }
}
BookingWaitlistService.DEFAULT_SERVICE_PATH = 'booking-management';
BookingWaitlistService.BASE_PATH = 'api/booking-waitlist';
//# sourceMappingURL=BookingWaitlistService.js.map